import { Switch } from 'react-router';
import PublicRoute from '@/routes/PublicRoute';
import { PATH_TERMS_OF_PRIVACY, PATH_TERMS_OF_SERVICE } from '@/constants/constant';
import TermsOfServicePage from '@/components/pages/terms/TermsOfServicePage';
import TermsOfPrivacyPage from '@/components/pages/terms/TermsOfPrivacyPage';

const TermsRoute = () => {
  return (
    <Switch>
      <PublicRoute path={PATH_TERMS_OF_SERVICE} component={TermsOfServicePage} />
      <PublicRoute path={PATH_TERMS_OF_PRIVACY} component={TermsOfPrivacyPage} />
    </Switch>
  );
};

export default TermsRoute;
